/* Esta clase carga los lenguajes desde un servicio que cada plugin puede implementar */
import VueI18n from 'vue-i18n'
import { CustomizationLoader } from 'CustomModules/loader'

let customLangs = {}
let remoteLoaders = []
CustomizationLoader.paths.forEach((path) => {
  /* Carga los idiomas personalizados */
  let langSettings = require(`CustomModules/${path}/langs`)
  langSettings.Langs.forEach((langKey) => {
    let lang = require(`CustomModules/${path}/lang/${langKey}`)
    for (let prop in lang) {
      if (lang.hasOwnProperty(prop)) {
        customLangs[prop] = lang[prop]
      }
    }
  })

  if (typeof langSettings.RemoteLoader === 'function') {
    remoteLoaders.push(langSettings.RemoteLoader)
  }
})

/* Carga de idiomas disponibles en el core */
let coreLangs = {}
let coreLangContext = require.context('./', false, /\.js$/)
coreLangContext.keys().forEach((key) => {
  let lang = coreLangContext(key)
  for (let prop in lang) {
    if (lang.hasOwnProperty(prop)) {
      coreLangs[prop] = lang[prop]
    }
  }
})
jQuery.extend(true, coreLangs, customLangs)

let i18n = null

class CoreLangLoader {
  static initInstance () {
    i18n = new VueI18n({
      locale: 'es',
      messages: coreLangs
    })
  }

  static getInstance () {
    if (i18n === null) {
      CoreLangLoader.initInstance()
    }
    return i18n
  }

  static loadRemoteLangs () {
    remoteLoaders.map((fn) => {
      fn((lang, messages) => {
        i18n.mergeLocaleMessage(lang, messages)
      }, (error) => {
        console.error('error cargando lenguajes remotos: ', error)
      })
    })
  }
}

export default CoreLangLoader

// Crea la instancia de VueI18n
/*
export const i18n = new VueI18n({
  locale: 'es',
  messages: coreLangs
})
*/



// WEBPACK FOOTER //
// ./src/lang/LangLoader.js